<!--
 * @Author: Junjie
 * @Date: 2022-12-07 15:56:54
 * @LastEditTime: 2022-12-08 13:58:48
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/tech/plant/modules/AutoRunningConfForm.vue
-->
<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开启" prop="autoOn">
              <j-switch v-model="model.autoOn"></j-switch>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="当前状态" prop="autoStatus">
              <a-tag>{{model.autoStatus === 'Y'? '系统自动运行中...' : '正常模式'}}</a-tag>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-tooltip title="在此时间段内交班，系统将会开启自动运行模式">
              <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="自动运行开始时间" prop="autoHourStart">
                <a-select :options="hoursList" placeholder="请选择自动运行开始时间" type="list" v-model="model.autoHourStart" />
              </a-form-model-item>
            </a-tooltip>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="自动运行结束时间" prop="autoHourEnd">
              <a-select :options="hoursList" placeholder="请选择自动运行结束时间" type="list" v-model="model.autoHourEnd" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <a-row>
      <a-col :span="22"></a-col>
      <a-col :span="2">
        <a-form-item>
          <a-button :loading="confirmLoading" @click="submitForm()" type="primary">保存</a-button>
        </a-form-item>
      </a-col>
    </a-row>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'AutoRunningConfForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          list: "/device/sewegePlantAutoConfig/list",
          add: "/device/sewegePlantAutoConfig/add",
          edit: "/device/sewegePlantAutoConfig/edit",
          queryById: "/device/sewegePlantAutoConfig/queryById"
        },
        hoursList: []
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.loadData();
      this.list24hours();
    },
    methods: {
      list24hours () {
        for (let index = 0; index < 24; index++) {
          const option = {
            key: index,
            value: index,
            title: `${index}时`,
          };
          this.hoursList.push(option);
        }
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      loadData () {
        getAction(this.url.list, {}).then(res => {
          if (res.success) {
            const originModel = res.result.records[0];
            if (originModel) {
              this.model = originModel;
            }
          } else {
            this.$message.error(res.message)
          }

        });
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>